import { request } from "./http-client"


export const getWorkingHours = (branch_id?: string, selected_date?: string) =>
  request.get(`/v1/branches/${branch_id}/working-hours?date=${selected_date}`);
